'use strict';

import { EwSiteApp } from '../../app/ewsiteapp';

EwSiteApp
  .controller('ProcessguideCtrl', [
    '$scope', '$filter', '$sce', '$log', '$timeout', '$element',
    function ($scope, $filter, $sce, $log, $timeout, $element) {
      // raw data → angular scope
      $timeout(() => {
        if (typeof processguideData !== 'undefined' && Array.isArray(processguideData)) {
          $scope.steps = processguideData;
          parseSearch();
          $scope.init();
        }
      }, 50);

      //––– STATE –––
      $scope.urlParams   = { url: '' };
      $scope.currentStep = {};
      let   searchObj    = '';
      let   queryString  = '';

      //––– parse out “?foo=bar” → searchObj
      function parseSearch() {
        queryString = window.location.search;
        let pairs  = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        if (pairs.length && pairs[0]) {
          searchObj = pairs[0];
        }
      }

      //––– build & push new ?string without wiping out #hash
      function formatHistoryQuery() {
        let el = [];
        for (let key in $scope.urlParams) {
          if ($scope.urlParams[key]) {
            el.push($scope.urlParams[key]);
          }
        }
        return el.join('&');
      }
      function setQueryData() {
        const qs  = '?' + formatHistoryQuery();
        const hash = window.location.hash;
        history.pushState('', document.title, window.location.pathname + qs + hash);
      }

      //––– if your step‐list is wide, slide center on the “.current” tile
      function scrollToCurrentStep() {
        if (!$scope.steps || $scope.steps.length <= 7) return;
        $timeout(() => {
          const wrap    = document.querySelector('.ctg__steps');
          const wrapMob = document.querySelector('.ctg__steps-mob');
          const curr    = document.querySelector('.ctg__step--current');
          const currMob = document.querySelector('.ctg__step-mob--current');
          if (!curr) return;

          const rW = wrap.getBoundingClientRect();
          const rC = curr.getBoundingClientRect();
          if (rC.left < rW.left) {
            wrap.scrollBy({ left: rC.left - rW.left - 19, behavior: 'smooth' });
          } else if (rC.right > rW.right) {
            wrap.scrollBy({ left: rC.right - rW.right + 19, behavior: 'smooth' });
          }

          if (currMob) {
            const rWM = wrapMob.getBoundingClientRect();
            const rCM = currMob.getBoundingClientRect();
            if (rCM.left < rWM.left) {
              wrapMob.scrollBy({ left: rCM.left - rWM.left - 19, behavior: 'smooth' });
            } else if (rCM.right > rWM.right) {
              wrapMob.scrollBy({ left: rCM.right - rWM.right + 19, behavior: 'smooth' });
            }
          }
        }, 0);
      }

      //––– NAVIGATION: goto any step by its ord
      $scope.gotoStep = function (ord) {
        const found = $filter('filter')($scope.steps, { ord: ord }, false);
        if (!found || !found.length) return;
        const step = found[0];

        $scope.urlParams.url = step.url;
        $scope.setCurrent(step);
        $scope.markPreviousStepsAsCompleted(step);
        setQueryData();
        scrollToCurrentStep();

        // re-toggle any theme-lists after render
        $timeout(() => {
          if (typeof window.processThemesListToggle === 'function') {
            window.processThemesListToggle();
          }
        }, 0);
      };

      //––– keyboard‐nav on steps
      $scope.handleStepKeypress = function ($event, step) {
        if ($event.key === 'Enter' || $event.key === ' ') {
          $scope.gotoStep(step.ord);
          $event.preventDefault();
        }
      };

      //––– convenience
      $scope.gotoFirstStep = function () {
        if ($scope.steps && $scope.steps.length) {
          $scope.gotoStep($scope.steps[0].ord);
        }
      };
      $scope.gotoPrevStep = function () {
        if (typeof $scope.currentStep.ord !== 'undefined') {
          $scope.gotoStep(parseInt($scope.currentStep.ord, 10) - 1);
        }
      };
      $scope.gotoNextStep = function () {
        if (typeof $scope.currentStep.ord !== 'undefined') {
          $scope.gotoStep(parseInt($scope.currentStep.ord, 10) + 1);
        }
      };

      //––– trust inner HTML
      $scope.explicitlyTrustedHtml = text => $sce.trustAsHtml(text);

      //––– mark one as current, bundle into scope.currentStep
      $scope.setCurrent = function (currentStep) {
        $scope.steps.forEach(s => s.current = false);
        currentStep.current = true;
        $scope.currentStep   = currentStep;
      };

      //––– mark everything before current as “completed”
      $scope.markPreviousStepsAsCompleted = function (currentStep) {
        let seen = false;
        $scope.steps.forEach(s => {
          if (s.id === currentStep.id) {
            seen = true;
          }
          s.completed = !seen;
        });
      };

      //––– initial chooser: URL match or first step
      $scope.init = function () {
        if (!$scope.steps || !$scope.steps.length) return;

        if (searchObj) {
          const q = $filter('filter')($scope.steps, { url: searchObj }, true);
          if (q && q.length) {
            return $scope.gotoStep(q[0].ord);
          }
        }
        // fallback
        $scope.gotoFirstStep();
      };
    }
  ])
  .directive('mobileOverflowTables', [
    '$window', '$timeout',
    function ($window, $timeout) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          function makeTablesScrollable() {
            element.find('table').each(function () {
              var tableEl = angular.element(this);
              if (tableEl.closest('.scrollable').length === 0) {
                if (tableEl.outerWidth() > tableEl.parent().outerWidth()) {
                  tableEl.wrap('<div class="scrollable"><div></div></div>');
                  tableEl.closest('.scrollable').addClass('has-scroll');
                }
              } else {
                if (tableEl.outerWidth() > tableEl.parent().outerWidth()) {
                  tableEl.closest('.scrollable').addClass('has-scroll');
                } else {
                  tableEl.closest('.scrollable').removeClass('has-scroll');
                }
              }
            });
          }

          scope.$watch(
            function () { return element.html(); },
            function (newVal, oldVal) {
              if (newVal !== oldVal) {
                $timeout(makeTablesScrollable, 0);
              }
            }
          );

          angular.element($window).on('resize orientationchange', function () {
            $timeout(makeTablesScrollable, 0);
          });

          // initial wrap
          $timeout(makeTablesScrollable, 0);
        }
      };
    }
  ]);
